import script from "./tabbed-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./tabbed-content.vue?vue&type=script&lang=ts&setup=true"

import "./tabbed-content.vue?vue&type=style&index=0&id=5dcc15ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcc15ae"]])

export default __exports__